import { useEffect } from 'react';

import { PostMessageEventNames } from '@/components/Payments/constants/postMessages';

export const usePaymentMessageListener = (
  onPaymentFinished: () => void,
  onPaymentFailed?: () => void
): void => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (
        event.data === PostMessageEventNames.PaymentFinished &&
        onPaymentFinished
      ) {
        onPaymentFinished();
      }

      if (
        (event.data === PostMessageEventNames.PaymentFailed ||
          event.data === 'paymentFailure') &&
        onPaymentFailed
      ) {
        onPaymentFailed();
      }
    };

    window.addEventListener('message', handleMessage, true);
    return () => window.removeEventListener('message', handleMessage, true);
  }, [onPaymentFinished, onPaymentFailed]);
};
